import { Box, Skeleton, Stack, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function PerformanceLoader() {
  const theme = useTheme();

  return (
    <>
      <Box mb={3} p={2} borderRadius={3} sx={{ background: '#ECECEC' }}>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack direction='row' spacing={2} alignItems='center'>
            <Skeleton variant='rounded' width={40} height={40} />

            <Stack spacing={0.5}>
              <Skeleton variant='text' width={220} height={26} />
              <Skeleton variant='text' width={320} height={18} />
            </Stack>
          </Stack>

          <Skeleton variant='rounded' width={110} height={32} sx={{ borderRadius: 20 }} />
        </Stack>
      </Box>
      {/* Header */}
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        mb={3}
        flexDirection={{ xs: 'column', lg: 'row' }}
        gap={2}
      >
        <Skeleton variant='text' width={140} height={32} />
        <Skeleton variant='rectangular' width={260} height={40} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Total Staff Time Saved Card */}
      <Box
        bgcolor='#fff'
        border='1px solid #ECECEC'
        borderLeft={`4px solid ${theme.palette.primary.main}`}
        borderRadius={2}
        p={2}
        mb={3}
      >
        <Grid container spacing={2} alignItems='center'>
          <Grid size={{ xs: 12, lg: 6 }} display='flex' gap={2.5}>
            <Skeleton variant='rounded' width={64} height={64} />

            <Stack spacing={1} width='100%'>
              <Skeleton variant='text' width={160} height={18} />
              <Skeleton variant='text' width={120} height={34} />
              <Skeleton variant='text' width={220} height={16} />
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, lg: 3 }}>
            <Stack spacing={1}>
              <Skeleton variant='text' width={130} height={18} />
              <Skeleton variant='text' width={90} height={30} />
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, lg: 3 }}>
            <Stack spacing={1}>
              <Skeleton variant='text' width={130} height={18} />
              <Skeleton variant='text' width={60} height={30} />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      {/* Metric Cards */}
      <Grid container spacing={2} mb={3}>
        {[1, 2, 3, 4].map((i) => (
          <Grid key={i} size={{ xs: 6, lg: 3 }}>
            <Box
              bgcolor='#fff'
              border='1px solid #ECECEC'
              borderRadius={2}
              p='16px'
              borderLeft={`4px solid ${theme.palette.primary.main}`}
            >
              <Stack direction='row' justifyContent='space-between'>
                <Skeleton variant='text' width={120} height={20} />
                <Skeleton variant='circular' width={32} height={32} />
              </Stack>

              <Skeleton variant='text' width={60} height={32} sx={{ mt: 1 }} />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Charts Row */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={3}>
            <Skeleton variant='text' width={220} height={28} sx={{ mb: 2 }} />
            <Skeleton variant='rectangular' width='100%' height={420} sx={{ borderRadius: 1 }} />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={3}>
            <Skeleton variant='text' width={180} height={28} sx={{ mb: 2 }} />
            <Skeleton variant='circular' width={240} height={240} sx={{ mx: 'auto', display: 'block', mt: 4 }} />
          </Box>
        </Grid>
      </Grid>
      {/* Tasks Completed Skeleton */}
      <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={3} mt={3}>
        <Skeleton variant='text' width={200} height={28} />
        <Skeleton variant='text' width={260} height={18} sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Grid key={idx} size={{ xs: 6, sm: 4, md: 2 }}>
              <Box border='1px solid #ECECEC' borderRadius='12px' p={2} textAlign='center'>
                <Skeleton variant='rounded' width={36} height={36} sx={{ mx: 'auto', mb: 1 }} />
                <Skeleton variant='text' width={40} height={28} sx={{ mx: 'auto' }} />
                <Skeleton variant='text' width={80} height={16} sx={{ mx: 'auto' }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* Inbound Volume by Hour */}
      <Box mt={3} bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={3}>
        <Skeleton variant='text' width={220} height={28} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={320} sx={{ borderRadius: 1 }} />
      </Box>
    </>
  );
}
